// extracted by mini-css-extract-plugin
export var avatarContainer = "_5f-1";
export var largeAvatarContainer = "_5f-2";
export var smallAvatarContainer = "_5f-0";